<template>
  <canvas
    :id="id"
    ref="lineCanvas"
    style="height: 100%; width: 100%"
    :style="styleLineChart"
  ></canvas>
  <div
    v-if="
      $route.name === 'CustomersSatisfactionReport' &&
      id === 'lineChartTwoLegends'
    "
    id="legend"
    class="legend"
  >
    <div class="legendItems">
      <div v-for="(el, index) in items" :key="index" class="item">
        <img
          class="item-img"
          :src="require(`@/assets/icons/${el.label}.png`)"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Chart,
  ChartOptions,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  Tooltip,
  Legend,
  Title,
  ChartData
} from 'chart.js';
import { items, optionsFirstChart } from './configs';

import type { ComponentPublicInstance, PropType, StyleValue } from 'vue';

Chart.register(
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title
);

/* eslint-disable */
export default {
  name: 'LineChart',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },
    dataLineChart: {
      type: Object as PropType<ChartData<'line'>>,
      required: true
    },
    optionsLineChart: {
      type: Object as PropType<ChartOptions<'line'>>,
      default: () => ({})
    },
    styleLineChart: {
      type: [Object, String] as PropType<StyleValue>,
      default: () => ({})
    }
  },
  data() {
    return {
      chart: null as any,
      items,
      optionsFirstChart
    };
  },
  mounted() {
    (this as any).createChart();
  },
  methods: {
    createChart() {
      const ctx = (this as any).$refs.lineCanvas as HTMLCanvasElement;

      const isCustomerReport =
        (this as any).$route.name === 'CustomersSatisfactionReport';

      if (!isCustomerReport) {
        const options: ChartOptions<'line'> = (this as any).optionsLineChart;

        (options.plugins as any).datalabels = { display: false };

        const myChart = new Chart(ctx, {
          type: 'line',
          data: (this as any).dataLineChart,
          options
        });
      } else {
        const options: ChartOptions<'line'> = {
          ...optionsFirstChart,
          plugins: {
            ...optionsFirstChart.plugins,
            title: {
              ...optionsFirstChart.plugins?.title,
              text: (this as any).$t('customersSatisfaction') as string
            }
          },
          scales: {
            ...optionsFirstChart.scales,
            y: {
              ...optionsFirstChart.scales?.y,
              max: 102,
              ticks: {
                display: false
              }
            }
          }
        };

        const myChart = new Chart(ctx, {
          type: 'line',
          data: (this as any).dataLineChart,
          options
        });
      }
    }
  },
  beforeUnmount() {
    const self = this as any;
    if (self.chart) {
      self.chart.destroy();
    }
  },
  watch: {
    dataPieChart: {
      handler(
        this: ComponentPublicInstance & { createChart(): void; chart: any }
      ) {
        if (this.chart) {
          this.chart.destroy();
        }
        this.createChart();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.legend {
  position: absolute;
  top: 56%;
  left: 4%;
  transform: translate(-50%, -50%);
  .legendItems {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 285px;
    @media (max-width: 1280px) {
      height: 236px;
    }
    .item {
      .item-img {
        width: 36px;
        height: 39px;
      }
    }
  }
}
</style>
